var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"affiliate-administration"},[_c(_setup.ActiveTokensCardTable,{staticClass:"affiliate-card__tokens",attrs:{"user-id":_setup.props.affiliate.user_id}}),(!_setup.loadingRoleCard)?_c(_setup.UserCardRoles,{staticClass:"affiliate-user__roles",attrs:{"user":_setup.affiliateUser}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }